import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import ErrorMsg from "../../components/form/errorMsg";
import { useDispatch } from "react-redux";
import { createSetting, viewSetting } from "../../redux/actions/settingAction";
import moment from "moment";
import ChangeSaved from "../../components/popups/ChangeSaved";
import ErrorPopup from "../../components/popups/ErrorPopup";

const OrderValidity = () => {
  const dispatch = useDispatch();
  const [settings, setSettings] = useState(null);
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  useEffect(() => {
    dispatch(viewSetting(onFetchSuccess, onFetchError));
  }, []);

  const onFetchSuccess = (data) => {
    console.log(data);
    setSettings(data?.data?.data?.setting);
  };
  const onFetchError = (err) => {
    console.log(err);
  };

  const initialValues = {
    order_validity: "",
  };
  const loginSchema = Yup.object().shape({
    order_validity: Yup.string().trim().required("* Required"),
  });
  const onSubmit = (values, { resetForm }) => {
    console.log(values);
    dispatch(createSetting(values.order_validity, onSuccess, onError));
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
    window.location.reload(false);
  }

  const onSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = (data.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  }

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = (err.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <div className="col-10  px-4 mx-1 mx-md-4 my-5">
      <div>
        <span className="fs_18 fw_400">Order Validity</span>
      </div>
      <span className="fs_16 color_747f9e">
        Enter the number of days all the orders will be valid for
      </span>
      <div className="mt-3">
        <span className="color_262c3d fs_14">Current Order Validity</span>
        <p>
          <span className="color_2ad3e7 fs_18 fw_600">
            {settings?.order_validity} days
          </span>
          <span className="color_b0b3c7 fs_12 ms-1">
            Updated{" "}
            {moment().diff(settings?.updatedAt, "months") > 0
              ? `${moment().diff(settings?.updatedAt, "months")} months ago`
              : `${moment().diff(settings?.updatedAt, "days")} days ago`}
          </span>
        </p>
      </div>
      <div className="settings-form-width w-75">
        <Formik
          initialValues={initialValues}
          validationSchema={loginSchema}
          onSubmit={onSubmit}
        >
          {(props) => (
            <Form>
              <label className="color_262c3d fs_14 fw_700">Order Validity</label>
              <Field name={"order_validity"}>
                {({ field, meta }) => (
                  <input
                    {...field}
                    placeholder="Enter order validity days"
                    id={"order_validity"}
                    type="number"
                    className={"w-100 support-input  p-2"}
                  />
                )}
              </Field>
              <ErrorMsg name="order_validity" />

              <div className="d-flex justify-content-end">
                <button className="settings-change-btn text-white px-3 py-1 fs_12">
                  Change
                </button>
              </div>
            </Form>
          )}
        </Formik>
        <ChangeSaved
          show={onSuccessShow}
          title={onSuccessMsg}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </div>
  );
};

export default OrderValidity;
